import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { View, ViewTitle } from "../../shared/styled/view";
import Loader from "../../shared/icons/tat/loader";
import Button from "../../shared/controls/button";
import OptionSelectorSwitch from "../../shared/controls/option-selector-switch";
import ImageWithCheckMark from "../../shared/component/image-with-check-mark";
import { getUrlsEnv } from "../../shared/backend-api";
import { cancelMultipleRequests, createEntity, partialEntity, readEntities, readEntity } from "../../redux/api/actions";
import { RequisitionDetailView } from "./tables/requisition-detail-table-view";
import { RequisitionView } from "./tables/requisition-table-view";
import { getEntityItems } from "../../redux/api";
import CatalogSelectionFooter from "../../shared/component/catalog-selection-footer";
import PaginatorControlled from "../../shared/controls/paginator-controlled";
import FilterBarCompact from "../../shared/component/filter/filter-bar-compact";
import { getTimeZone, setCurrentCommandTabSelected } from "../../shared/utils";
import CreateOrderModal from "./create-order-modal";
import { sendMessageToMultipleUsersInSocket, showSimpleFlashNotification } from "../../shared/utils";
import moment from 'moment';
import GenericDialog from "../../shared/dialog/generic-modal";
import DivideRequisitionDeliveryModal from "../../shared/dialog/divide-requisition-delivery-modal";
import AddProductRequisitionDeliveryModal from "../../shared/dialog/add-product-requisition-delivery-modal";
import ConfirmRequisitionModal from "../../shared/dialog/confirm-requisition-modal";
import ModifyProductDeliveryModal from "../../shared/dialog/modify-product-delivery-modal";
import ConvertDeliveryToOrderModal from "../../shared/dialog/convert-delivery-to-order-modal";
import CustomDatePicker from "../../shared/component/custom-date-picker";
import { cloneDeep } from "lodash";
import { setOrderSeleted } from "../../redux/reducers/global-catalog.reducer";

const TRANSACTIONS = [
  { description: "Compra", value: 1 },
  { description: "Venta", value: 2 },
]

class RequisitionsControlView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      collapseAll: true,
      limit: 50,
      offset: 1,
      getOrdersCalled: false,
      seed: Math.random(),
      emails: [],
      buttonFilterName: "Aplicar",

      isAllProductsSelected: false,
      isAllRequisitionsSelected: false,
      selectionModeOn: false,
      requisitionFilter: null,
      requisitionId: null,
      moreProducts: true,

      current_facilities: [],
      appointment: [],
      appointment_type: [],
      requisition_status: [],
      facilities_selected: [],

      facilities: [],
      productsSelected: [],
      requisitionsSelected: [],
      requisitionDetail: null,
      transactionType: props?.history?.location?.state?.transactionType || 1,

      showCreateOrderModal: false,
      productsToAdd: [],
      selectedProvider: 0,
      selectedFacility: 0,
      selectedTags: [],
      selectedCode: "",
      selectedDate: null,
      selectedLevel: 1,
      selectedClass: 0,
      selectedDate: null,
      providerFacilities: [],
      selectedDestiny: 0,
      facilityCatalog: [],
      test_modal: null,
      selectedOrdersId: [],
      error_message: null,
      divideRequisitionDelivery: null,
      addProductRequisitionDelivery: null,
      confirmRequisitionData: null,
      confirmRequisitionsModal: false,
      cancelRequisitionsModal: false,
      deleteDelivery: null,
      modifyProductData: null,
      removeUniqueProductData: null,
      convertDeliveryToOrderRequisition: null,
      convertDeliveryToOrderDeliveries: [],
      facilityData: null,
      modifyDeliveryCollectionDate: null,
      modifyDeliveryDeliveryDate: null,
      selectedClient: null,
      codesNotFound: [],
      errorMessage: null
    }
  }

  componentDidMount() {
    if (this.props.location.search.includes('facilities')) {
      const query = new URLSearchParams(this.props.location.search);

      let codes = `${query.get('codes') || ''}`;

      this.setState({
        current_facilities: `${query.get('facilities')}`.split(',').map(item => parseInt(item)),
        facilities_selected: `${query.get('facilities')}`.split(','),
        emails: codes === '' ? [] : codes.split(',').map( item => ({
          email: item, avatar: 'hide', avatarType: '', userId: null
        }))
      }, () => {

        // if (this.state.current_facilities.length === 1) {
        //   this.props.loadFacilityInfo({
        //     company_id: this.props.companyId,
        //     id: this.state.current_facilities[0]
        //   }, {
        //     onSuccess: (response) => {
        //       this.setState({
        //         facilityData: response
        //       });
        //     }
        //   });
        // }

        this.loadFacilities();

      });
    }

    this.props.loadCompanyProviders({
      company_id: this.props.companyId,
    });

    this.props.loadCompanyTags({
      company_id: this.props.companyId
    })

    this.props.loadRequisitionFilterConfig({
      company_id: this.props.companyId
    }, {
      onSuccess: (response) => {
        this.state.deliveryFilter = response.delivery_filter || null;
        this.state.requisitionFilter = response.requisition_filter || null;
        this.loadItems();
      },
      onError: () => {
        this.loadItems();
      }
    });
  }

  loadProviderProducts = (search_value, offset) => {
    if (this.state.selectedProvider === '-1') {
      this.props.loadProducts({
        company_id: this.props.companyId,
        view: 'short_detail',
        tags: '',
        skus: '',
        products: '',
        search: search_value || '',
        limit: '',
        offset: offset || '',
        isMultipleCancels: true
      }, {
        onSuccess: (response) => {
          this.setState({
            moreProducts: `${offset}` === '1' ? true : response.length > 0,
            providerProducts: `${offset}` === '1' ? response : this.state.providerProducts.concat(response)
          })
        }
      });
      return
    }

    this.props.loadProviderProducts({
      company_id: this.props.companyId,
      network_id: this.state.selectedProvider,
      search: search_value || '',
      offset: offset || '',
      isMultipleCancels: true
    }, {
      onSuccess: (response) => {
        this.setState({
          moreProducts: `${offset}` === '1' ? true : response.length > 0,
          providerProducts: `${offset}` === '1' ? response : this.state.providerProducts.concat(response)
        })
      }
    });
  }

  loadFacilities = () => {
    this.props.loadOwnFacilities({
      company_id: this.props.companyId,  
    }, {
      onSuccess: (response) => {

        let tags = Object.entries(response);
        let all_facilities_group = [];

        tags.map( (item, index) => {

          if (item.length > 1) {

            let item_to_add = {
              id: index,
              description: `${item[0]}` === 'null' ? 'Sin tag' : item[0],
              label: `${item[0]}` === 'null' ? 'Sin tag' : item[0]
            }
            let facilities = [];

            (item[1] || []).map( item_2 => {

              facilities.push({
                id: item_2.id,
                description: `${item_2.name}`,
                label: `${item_2.name} - ${item_2.alias} - ${item_2.code}`,
                value: `${item_2.id}`,
              });              

            });

            item_to_add.items = facilities;
            item_to_add.options = facilities;

            if (facilities.length > 0) {
              all_facilities_group.push(item_to_add);
            }

          }

        });

        this.setState({
          facilityCatalog: all_facilities_group,
        });
      }

    });
  } 

  setFacilities = (response) => {
    try {

      let tags = Object.entries(response);
      let all_facilities_group = [];

      tags.map( item => {

        if (item.length > 1) {

          let item_to_add = {
            label: `${item[0]}` === 'null' ? 'Sin tag' : item[0]
          }
          let facilities = [];

          (item[1] || []).map( item_2 => {
            facilities.push({
              value: `${item_2.id}`,
              id: item_2.id,
              label: `${item_2.name} - ${item_2.alias} - ${item_2.code}`
            });

          });

          item_to_add.options = facilities;
          all_facilities_group.push(item_to_add);
        }

      });

      this.setState({
        providerFacilities: all_facilities_group
      });
      
    } catch(e) {
      console.log(`Error setting facilities with tag ${e}`);
    }
  }

  loadProviderFacilities = () => {
    if (this.state.selectedProvider === '-1') {
      this.props.loadOwnFacilities({
        company_id: this.props.companyId,  
      }, {
        onSuccess: (response) => {
          this.setFacilities(response)
        }
      })
      return
    }

    this.props.loadProviderFacilities({
      company_id: this.props.companyId,
      network_id: this.state.selectedProvider
    }, {
      onSuccess: (response) => {
        this.setFacilities(response)
      }
    });
  }

  loadItems = () => {
    if (this.state.getOrdersCalled) {
      this.props.cancelMultipleRequests();
    }

    this.setState({ getOrdersCalled: true });

    let codes = this.state.emails.map( item => item.email);
    let params = {};

    if (codes.length > 0) {
      params = {
        company_id: this.props.companyId,
        from_facility: this.state.transactionType === 2 ? this.state.facilities_selected : '',
        to_facility: this.state.transactionType === 1 ? this.state.facilities_selected : '',
        appointment: '',
        appointment_type: '',
        requisition_status: '',
        requisition_codes: codes,
        limit: this.state.limit,
        offset: this.state.offset,
        isMultipleCancels: true,
        timezone: getTimeZone()
      };
    } else {
      params = {
        company_id: this.props.companyId,
        from_facility: this.state.transactionType === 2 ? this.state.facilities_selected : '',
        to_facility: this.state.transactionType === 1 ? this.state.facilities_selected : '',
        appointment: this.state.appointment[0] ? "".concat(this.state.appointment[0].toISOString(), ",", this.state.appointment[1] ? this.state.appointment[1].toISOString() : this.state.appointment[0].toISOString()) : "",
        appointment_type: this.state.appointment_type,
        requisition_status: this.state.requisition_status,
        requisition_codes: '',
        limit: this.state.limit,
        offset: this.state.offset,
        isMultipleCancels: true,
        timezone: getTimeZone()
      };
    }

    this.props.loadFacilityRequisitions(params, {
      onSuccess: response => {
        if (this.state.requisitionId !== null) {
          (response.results || []).map( item => {
            if (item.id === this.state.requisitionId) {
              this.state.requisitionDetail = item; 
            }
          });
        }


        if (codes.length > 0) {
          this.state.codesNotFound = [];
          codes.map(code => {
            let requisition_found = (response.results || []).find( requisition => requisition.code.toLowerCase().includes(code.toLowerCase())); 

            if (!requisition_found) {
              this.state.codesNotFound.push(code);
            }
          })
        }

        this.setState({seed: Math.random(), requisitionId: null});
      }
    });
  }

  handleGridChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    switch(name) {
      case 'order_selected':

        if (value.trip_id) {
          this.props.setOrderDetail(value.order_code);
          this.props.history.push(`/company/controls/shipment/orderdetail/${value.trip_id}/?transaction=true`);
        } else {
          this.props.history.push(`/company/controls/shipment/orderdetail/${value.order_id}/?isOrder=true&transaction=true`);
        }

        break;
      case 'modify_delivery_collection_date':
        this.setState({
          modifyDeliveryCollectionDate: value
        });
        break;
      case 'modify_delivery_delivery_date':
        this.setState({
          modifyDeliveryDeliveryDate: value
        });
        break;
      case 'cancel-requisition-from-actions':
        this.setState({
          cancelRequisitionsModal: true,
          cancelRequisitionFromActions: value
        });
        break;
      case 'load_items':
        this.setState({
          requisitionDetail: null,
          requisitionsSelected: [],
          errorMessage: value?.error || null
        });
        this.loadItems();
        break;
      case 'convert_delivery_to_order':

        if (value.deliveries.length === 1 && this.state.requisitionDetail) {

          this.props.getDeliveryInfo({
            delivery_id: value.deliveries[0].id,
            requisition_id: this.state.requisitionDetail.id,
            company_id: this.props.companyId,
            isMultipleCancels: true
          }, {
            onSuccess: (r) => {
              
              if (r.order_id !== null) {
                this.setState({
                  error_message: 'Esta entrega ya tiene una orden vinculada',
                  requisitionId: this.state.requisitionDetail.id,
                });
                this.loadItems();

              } else {
                this.setState({
                  convertDeliveryToOrderRequisition: this.state.requisitionDetail ? this.state.requisitionDetail : value.requisition,
                  convertDeliveryToOrderDeliveries: value.deliveries
                });
              }

            },
            onError: (e) => {
              this.setState({
                error_message: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
              });
            }
          });

        } else if (value.deliveries.length > 0) {

          this.props.getRequisitionInfo({
            delivery_id: value.deliveries[0].id,
            requisition_id: value.requisition.id,
            company_id: this.props.companyId,
            isMultipleCancels: true
          }, {
            onSuccess: (r) => {

              let hasDeliveriesToConvert = false;

              (r.deliveries || []).map(item => {
                if (item.order_id === null) {
                  hasDeliveriesToConvert = true;
                }
              });
              
              if (!hasDeliveriesToConvert) {
                this.setState({
                  error_message: 'Este pedido no tiene entregas para convertir a orden',
                });
                this.loadItems();

              } else {
                this.setState({
                  convertDeliveryToOrderRequisition: this.state.requisitionDetail ? this.state.requisitionDetail : value.requisition,
                  convertDeliveryToOrderDeliveries: value.deliveries
                });
              }

            },
            onError: (e) => {
              this.setState({
                error_message: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
              });
            }
          });

        } else {

          this.setState({
            convertDeliveryToOrderRequisition: this.state.requisitionDetail ? this.state.requisitionDetail : value.requisition,
            convertDeliveryToOrderDeliveries: value.deliveries
          });

        }

        break;
      case 'delete-delivery':
        this.setState({
          deleteDelivery: value
        });
        break;
      case 'modify_product_data':

        let data = {
          product_id: value.id,
          delivery_id: value.delivery_id,
          requisition_id: this.state.requisitionDetail.id,
          company_id: this.props.companyId,
          isMultipleCancels: true
        }

        this.props.getDeliveryProduct(data, {
          onSuccess: (r) => {
            this.setState({
              modifyProductData: r
            });
          },
          onError: (e) => {
            this.setState({
              error_message: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
            });
          }
        });
        break;
      case 'remove_unique_product_data':
        this.setState({
          removeUniqueProductData: value
        });
        break;
      case 'confirm_requisition': 
        this.setState({
          confirmRequisitionData: value
        });
        break;
      case 'divide_delivery':
        this.setState({
          requisitionDetail: null,
          requisitionId: value.requisition_id || null
        });
        this.loadItems();
        break;
      case 'new_products_added':
        this.setState({
          requisitionDetail: null,
          requisitionId: value.requisition_id || null
        });
        this.loadItems();
        break;
      case 'products_selected':

        let products_selected = this.state.productsSelected || [];
        let products_to_remove = value.filter( item => item.selected === false).map( item => item.id);
        if (products_to_remove.length > 0) {
          products_selected = products_selected.filter( item => !products_to_remove.includes(item.id) );
        }

        let products_to_add = value.filter( item => item.selected).map( item => ({id: item.id, delivery_id: item.delivery_id, product_name: item.product_name}));
        if (products_to_add.length > 0) {
          products_selected = products_selected.concat(products_to_add);
        }

        products_selected = products_selected.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.id === value.id
          ))
        );
        
        this.setState({
          productsSelected: products_selected
        });
        break;
      case 'add-new-product':
        this.setState({
          addProductRequisitionDelivery: value
        });
        break;
      case 'save-deliveries':

        break;
      case 'divide-requisition-delivery':
        this.setState({
          divideRequisitionDelivery: value
        });
        break;
      case 'test':
        this.setState({
          test_modal: value
        });
        break;
      case 'requisition_detail':
        if (this.state.test_modal !== null || this.state.confirmRequisitionData || this.state.removeUniqueProductData || this.state.modifyProductData || this.state.convertDeliveryToOrderRequisition) break;

        this.setState({
          requisitionDetail: value,
          requisitionsSelected: [],
          isAllRequisitionsSelected: false,
          isAllProductsSelected: false
        });
        break;
      case 'requisitions_selected':
        this.setState({
          requisitionsSelected: value
        });
        break;
      default:
        console.log('no action');
    }

  }

  isSellingRequisition = () => {
    if (this.state.requisitionDetail) {
      let facility_id = this.state.requisitionDetail?.from_facility?.id || 0;
      return this.state.current_facilities.includes(facility_id);
    }

    return false;
  }

  getTitleValue = () => {
    if (this.state.facilityData) {
      return this.state.requisitionDetail !== null ? `Detalle de Pedido de ${this.isSellingRequisition() ? 'Venta' : 'Compra'}` : `Control de Pedidos ${this.state.facilityData["name"] || ""}`;
    }

    return this.state.requisitionDetail !== null ? `Detalle de Pedido de ${this.isSellingRequisition() ? 'Venta' : 'Compra'} ${this.state.requisitionDetail?.code}` : 'Control de Pedidos';
  }

  getDetailHeader = () => {
    if (this.state.requisitionDetail === null) {
      return '';
    }

    let from_company = this.state.requisitionDetail.from_company;
    let to_company = this.state.requisitionDetail.to_company;

    return(
      <div style={{display: 'flex', marginLeft: 18}}>

        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{fontWeight: 800}}>{'Proveedor:'}</div>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <ImageWithCheckMark
              src={getUrlsEnv().files.concat(from_company.logo?.substring(1) || '')}
              width={45}
              isCheckMark={from_company.verification_status === 3}
              customStyle={{
                width: 45, height: 45, borderRadius: '50%', position: 'relative', marginRight: 12
              }}
              type={from_company.type_id}
            />
            
            <div style={{fontSize: 22}}>{`${from_company.orbi_id}`}</div>
          </div>
        </div>

        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: 20}}>
          <div style={{fontWeight: 800}}>{'Cliente:'}</div>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <ImageWithCheckMark
              src={getUrlsEnv().files.concat(to_company.logo?.substring(1) || '')}
              width={45}
              isCheckMark={to_company.verification_status === 3}
              customStyle={{
                width: 45, height: 45, borderRadius: '50%', position: 'relative', marginRight: 12
              }}
              type={to_company.type_id}
            />
            
            <div style={{fontSize: 22}}>{`${to_company.orbi_id}`}</div>
          </div>
        </div>

      </div>
    );

  }

  getFacilitiesDetailHeader = () => {
    if (this.state.requisitionDetail === null) {
      return '';
    }

    let from_facility = this.state.requisitionDetail.from_facility;
    let from_facility_company = this.state.requisitionDetail.from_facility?.company;
    let to_facility = this.state.requisitionDetail.to_facility;
    let to_facility_company = this.state.requisitionDetail.to_facility?.company;

    return(
      <div style={{display: 'flex'}}>

        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{fontWeight: 800}}>{'Origen:'}</div>

          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {
              from_facility_company ?
              <ImageWithCheckMark
                src={getUrlsEnv().files.concat(from_facility_company.logo?.substring(1) || '')}
                width={45}
                isCheckMark={from_facility_company.verification_status === 3}
                customStyle={{
                  width: 45, height: 45, borderRadius: '50%', position: 'relative', marginRight: 12, marginLeft: 18
                }}
                type={from_facility_company.type_id} 
              /> : <div/>
            }

            <div>{`${from_facility.name}, ${from_facility_company.orbi_id ?? ''}`}</div>
          </div>

        </div>

        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{fontWeight: 800}}>{'Destino:'}</div>
          
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {
              to_facility_company ?
              <ImageWithCheckMark
                src={getUrlsEnv().files.concat(to_facility_company.logo?.substring(1) || '')}
                width={45}
                isCheckMark={to_facility_company.verification_status === 3}
                customStyle={{
                  width: 45, height: 45, borderRadius: '50%', position: 'relative', marginRight: 12, marginLeft: 18
                }}
                type={to_facility_company.type_id} 
              /> : <div/>
            }

            <div>{`${to_facility.name}, ${to_facility_company.orbi_id ?? ''}`}</div>
          </div>

        </div>
      </div>
    );

  }

  getHeaderInfoSelection = () => { 
    if (this.state.requisitionDetail) {
      return(
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#afc8ff'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              backgroundColor: 'rgb(29, 37, 52)',
              borderRadius: '15px 15px 0px 0px',
              height: 100
            }}
          >
            {this.getDetailHeader()}

            {this.getFacilitiesDetailHeader()}

            <div 
              style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 28, cursor: 'pointer'}}
              onClick={() => this.setState({requisitionDetail: null, productsSelected: [], isAllProductsSelected: false})}
            >
              <div style={{fontSize: 18}}>{'ᐸ Regresar a Pedidos'}</div>
            </div>
          </div>
        </div>
      );
    } else {
      return(
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#afc8ff'
          }}
        >
          {/* <div style={{height: 60}}/> */}
        </div>
      );
    }
  }

  getCount = () => {
    return this.props.requisitionsCount;
  }

  handleTabChange = (e) => {
    const { name, value } = e.target;

    if (name === 'transactionType') {
      setCurrentCommandTabSelected(null, value, null);
      this.state.requisitionDetail = null;
    }

    this.setState({ [name]: value, selectedOrdersId: [], offset: 1}, () => {this.loadItems()});
  };

  getCancelRequisitionErrors = () => {
    let errors = [];
    let requisitions_incorrect_status = (this.props.requisitionsData || []).filter( item => [3,4].includes((item.status?.id || 0)) && this.state.requisitionsSelected.includes(item.id));

    if (requisitions_incorrect_status.length > 0) {
      errors.push(`Los pedidos ${ requisitions_incorrect_status.map( item => item.code).join(', ') } no están en estatus para cancelar`);
    }

    let requisitions = (this.props.requisitionsData || []).filter( item => [1,2].includes((item.status?.id || 0)) && this.state.requisitionsSelected.includes(item.id));
    let deliveries = [];

    requisitions.map( item => {
      (item.deliveries || []).map( delivery => {
        if (delivery.order_id !== null) {
          deliveries.push(delivery);
        }
      })
    });

    if (deliveries.length > 0) {
      errors.push(`Las entregas ${ deliveries.map( item => `${item.requisition_code}-${item.suffix}`).join(', ') } ya están vinculadas a una orden`);
    }

    return errors.length > 0 ? errors.join(', ') : null;
  }

  getConfirmRequisitionErrors = () => {
    let requisitions_incorrect_status = (this.props.requisitionsData || []).filter( item => [2,3,4].includes((item.status?.id || 0)) && this.state.requisitionsSelected.includes(item.id));

    if (requisitions_incorrect_status.length > 0) {
      return `Los pedidos ${ requisitions_incorrect_status.map( item => item.code).join(', ') } no están en estatus para confirmar`;
    }

    return null;
  }

  getProductsError = () => {

    let delivery_ids = [];

    if (this.state.productsSelected && this.state.productsSelected.length > 0) {

      (this.state.productsSelected || []).map( item => {
        if (!delivery_ids.includes(item.delivery_id)) {
          delivery_ids.push(item.delivery_id);
        }
      })

    }

    if (delivery_ids.length > 0) {
      let error_deliveries = [];

      (delivery_ids).map(item => {
        let delivery = (this.state.requisitionDetail?.deliveries || []).find( delivery => delivery.id === item);
        
        if (delivery) {
          let products_selected = (this.state.productsSelected || []).filter( product => product.delivery_id === item);

          if (products_selected && products_selected.length >= delivery.products.length) {
            error_deliveries.push(`${delivery.requisition_code}-${delivery.suffix}`);
          }
        }

      });

      if (error_deliveries.length > 0) {
        return `No se pueden eliminar todos los productos de ${ error_deliveries.length > 1 ? 'las entregas ' : 'la entrega '  } ${error_deliveries.join(', ')}`;
      }

    }

    return null;
  }

  handleEmailInput = (e) => {
    if (e) {
      switch (e.target.name) {
        case "inviteTags":
          let mails = e.target.value
            .map((i) => ({
              email: i.email,
              avatar: "hide",
              avatarType: "",
              userId: null,
            }));
          this.setState({ 
            emails: mails, 
            searchStr: e.target.value.map(e => e.email), 
            offset: 1,
            buttonFilterName: "Aplicar"
          }, this.loadItems);
          break;
        case "deleteTags":
          this.setState({ emails: [].concat(e.target.value), searchStr: e.target.value.map(e => e.email), offset: 1 }, this.loadItems);
          break;
        default:
      }
    }
  };

  filterContent = () => {
    let dateTypes = [
      {
        id: "1",
        description: "Fecha estimada de recolección"
      },
      {
        id: "2",
        description: "Fecha estimada de entrega"
      },
      {
        id: "3",
        description: "Fecha de creación de pedido"
      },
      {
        id: "4",
        description: "Fecha de cancelación"
      },
      {
        id: "5",
        description: "Fecha de confirmación"
      }
    ];

    let requisitionTypes = [
      {
        id: "1",
        description: "Pendiente"
      },
      {
        id: "2",
        description: "Confirmado"
      },
      {
        id: "3",
        description: "Cancelado"
      },
      {
        id: "4",
        description: "Completado"
      }
    ];

    return(
      [
        {
          title: "Instalaciones",
          items:  this.state.facilityCatalog,
          name: "facilities_selected",
          listType: 5,
        },
        {
          title: "Fecha",
          name: "appointment",
          listType: 7,
          time: true
        },
        {
          title: "Tipo fecha",
          items: dateTypes,
          name: "appointment_type",
          listType: 5
        },
        {
          title: "Estatus",
          items: requisitionTypes,
          name: "requisition_status",
          listType: 5
        }
      ]
    );
    
  }

  resetModal = () => {
    this.setState({
      productsToAdd: [],
      selectedProvider: 0,
      selectedFacility: 0,
      selectedTags: [],
      selectedOrdersId: [],
      selectedCode: "",
      selectedDate: null,
      selectedLevel: 1,
      selectedClass: 0,
      providerProducts: [],
      providerFacilities: [],
      selectedDestiny: 0,
      selectedClient: null
    })
  }

  handleModalChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    switch(name){
      case 'selectedCode':
        this.setState({[name]: value.replace(/\s/g, '')});
        break;
      case 'selectedClient':
        this.setState({[name]: value});
        break;
      case 'selectedFacility':
        this.state.selectedDestiny = null;
        this.setState({[name]: value});
        break;
      case "validateSignature":
        let found_callback_ = value.found_callback || null;
        let no_found_callback_ = value.no_found_callback || null;

        this.props.validateSignatureTrip({
          company_id: this.props.companyId,
          view: 'validate',
          signature: this.state.selectedCode
        }, {
          onSuccess: (response) => {

            if ('is_found' in response && response.is_found && found_callback_) {
              found_callback_()
            } else {
              if (no_found_callback_) no_found_callback_();
            }

          }
        });

      break;
      case "validateCode":
        let found_callback = value.found_callback || null;
        let no_found_callback = value.no_found_callback || null;

        let from_company_info = (this.props.companyProviders || []).find(fC => fC.value === this.state.selectedProvider);

        this.props.validateCodeOrder({
          company_id: this.props.companyId,
          view: 'validate_requisition',
          code: this.state.selectedCode,
          from_company_id: from_company_info.id || 0,
          to_company_id: this.props.companyType === 3 ? this.state.selectedClient : this.props.companyId
        }, {
          onSuccess: (response) => {

            if ('is_found' in response && response.is_found && found_callback) {
              found_callback()
            } else {
              if (no_found_callback) no_found_callback();
            }

          }
        });
      break;
      case "searchProduct":
        let search_value = value.search_value || '';
        let offset = value.offset || '';

        this.props.cancelMultipleRequests();
        this.loadProviderProducts(search_value, offset);
        break;
      case "selectedProvider": 
        this.setState({
          selectedProvider: value, 
          selectedFacility: 0,
          providerProducts: [],
          productsToAdd: []
        }, () => {
          this.loadProviderFacilities();
          this.loadProviderProducts('','');
        });
        break;
      // case "addProduct":
      //   this.setState({productsToAdd: this.state.productsToAdd.concat([{id: value.id, qty: value.qty}])})
      //   break;
      case "updateProduct":
        let products = this.state.productsToAdd.filter(p => p.id !== value.id);
        // let index = this.state.productsToAdd.map(p => p.id).indexOf(value.id);
        // let selectedProduct = products.splice(index,1)[0];
        if(value.qty){
          products.push({
            id: value.id,
            qty: value.qty,
            gross_weight: value.gross_weight || 0,
            gross_weight_description: value.gross_weight_description || '',
            net_weight: value.net_weight || 0, 
            net_weight_description: value.net_weight_description || '',
            volume: value.volume || 0,
            volume_description: value.volume_description || '',
            qty_per_sku: value.qty,
            product_unit_description: value.product_unit_description || '',
            data: value.data || {},
            product: value.product
          })
        }
        this.setState({productsToAdd: products});
        break;
      case "removeProduct":
        let products1 = this.state.productsToAdd.filter(p => p.id !== value);
        // let index = this.state.productsToAdd.map(p => p.id).indexOf(value.id);
        // let selectedProduct = products.splice(index,1)[0];
        this.setState({productsToAdd: products1});
        break;
      
      case "consolidateOrder":
        let order = this.getItemsData().find(r => r.id === this.state.selectedOrdersId[0]) || {};
        let date = this.state.selectedDate ? (new Date(this.state.selectedDate)).toISOString() : null;
        
        let packages = [];
        let pallets = [];
        if(this.state.itemType === 1) packages = this.props.requisitionsData.filter(r => this.state.selectedOrdersId.includes(r.id)).map(r => r.package_requisition.map(p => ({id: p.id}))).flat();
        if(this.state.itemType === 3 ) pallets = this.state.selectedOrdersId.map(sO => ({id: sO}))
        //debugger;
        this.props.createOrder({
          company_id: this.props.companyId,
          code: this.state.selectedCode,
          from_company: order.from_facility.company || 0,
          to_company: order.from_facility.company || 0,
          from_facility: order.from_facility.id || 0,
          to_facility: order.to_facility.id || 0,
          // requisition_order: this.state.selectedOrdersId.map(sO => ({id: sO})),
          packages_order: packages,
          pallets_order: pallets,
          ordertag_order: this.state.selectedTags.map(sO => ({tag: sO})),
          appointment_unload_date: date,
          priority: this.state.selectedLevel,
          client_id: this.props.companyType === 3 ? this.state.selectedClient : this.props.companyId
        }, {
          onSuccess: () => {
            value && value();
            this.loadItems();
          }
        })
        break;
      case "consolidateTrip":
        // let order = this.props.requisitionsData.find(r => r.id === this.state.selectedOrdersId[0]) || {};
        // let date = this.state.selectedDate ? (new Date(this.state.selectedDate)).toISOString() : null;
        this.props.createTrip({
          company_id: this.props.companyId,
          signature: this.state.selectedCode,
          // from_company: order.from_facility.company,
          // to_company: order.from_facility.company,
          // from_facility: order.from_facility.id,
          // to_facility: order.to_facility.id,
          order_trip: this.state.selectedOrdersId.map(sO => ({id: sO})),
          triptag_trip: this.state.selectedTags.map(sO => ({tag: sO})),
          transport_class: Number(this.state.selectedClass)
          // appointment_unload_date: date,
          // priority: this.state.selectedLevel,
        }, {
          onSuccess: () => {
            value && value();
            this.loadItems();
          }
        })
        break;
      case "createOrder":
        let reqProducts = [];
        this.state.productsToAdd.forEach(p => {
          let qty = Number(p.qty);
          reqProducts.push({id: p.id, data: p.data, qty})
        });

        let delivery_date = null;

        if (this.state.selectedDate !== null && this.state.selectedDate !== '') {
          delivery_date = moment(this.state.selectedDate, "MM/DD/YYYY").format('YYYY-MM-DD');
        }

        let from_company = (this.props.companyProviders || []).find(fC => fC.value === this.state.selectedProvider);

        this.props.createRequisitionV2({
          company_id: this.props.companyId,
          products: reqProducts,
          from_facility: Number(this.state.selectedFacility),
          to_facility: this.state.facilityData ? Number(this.state.current_facilities[0]) : Number(this.state.selectedDestiny),
          code: this.state.selectedCode,
          network_id: this.state.selectedProvider !== '-1' ? Number(this.state.selectedProvider) : null,
          delivery_date,
          from_company_id: from_company.id || 0,
          to_company_id: this.props.companyType === 3 ? this.state.selectedClient : this.props.companyId,
          last_facility: Number(this.state.selectedDestiny)
        }, {
          onSuccess: (result) => {
            value();
            this.loadItems();

            showSimpleFlashNotification('Se creó con éxito el pedido', null);

            try {
              sendMessageToMultipleUsersInSocket(
                this.props.userId,
                result['users'],
                result['data']
              );
            } catch(e) {
              console.log('requisition creation error:', e)
            }

          },
          onError: (e) => {
            this.resetModal();
            this.setState({
              showCreateOrderModal: false,
              error_message: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
            })
          }
        });
        break;
      default:
        // debugger;
        this.setState({[name]: value});
    }
  }

  // Funciones para los modales
  getItemsData = () => {
    return this.props.requisitionsData;
  }

  getRequisitionsToConfirm = () => {
    let requisitions = (this.props.requisitionsData || []).filter( item => (item.status?.id || 0) === 1 && this.state.requisitionsSelected.includes(item.id));
    let deliveries = [];

    requisitions.map( item => {
      deliveries = deliveries.concat(item.deliveries)
    });

    return {requisitions, deliveries};
  }

  transformToDate = (data) => {
    let date_string = data.date || null;
    if (date_string) {
      let components = date_string.split('/');
      if (date_string.length > 2) {
        return(
          new Date(
            components[2],
            components[1] - 1,
            components[0]
          )
        );
      }
    }

    return null;
  }

  handleDataChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (this.props.isCallDeliveryActions) return;
    let data = null;

    if (this.state.modifyDeliveryCollectionDate) {
      let dates = value.date.split('-')
      let raw_date = (dates.length > 2) ? `${dates[2]}/${dates[1]}/${dates[0]}`: '';

      data = {
        company_id: this.props.companyId,
        facility: this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) :  Number(this.state.requisitionDetail.from_facility.id),
        last_facility: this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) :  Number(this.state.requisitionDetail.from_facility.id),
        collection_date: value.date,
        collection_date_raw: raw_date,
        delivery: `${this.state.modifyDeliveryCollectionDate.order_code}-${this.state.modifyDeliveryCollectionDate.suffix}`,
        delivery_id: this.state.modifyDeliveryCollectionDate.id,
        requisition_id: this.state.requisitionDetail.requisition_id,
        action: 'modify_collection_date'
      }

    } else if (this.state.modifyDeliveryDeliveryDate) {

      let dates = value.date.split('-')
      let raw_date = (dates.length > 2) ? `${dates[2]}/${dates[1]}/${dates[0]}`: '';

      data = {
        company_id: this.props.companyId,
        facility: this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) :  Number(this.state.requisitionDetail.from_facility.id),
        last_facility: this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) :  Number(this.state.requisitionDetail.from_facility.id),
        delivery_date: value.date,
        delivery_date_raw: raw_date,
        delivery: `${this.state.modifyDeliveryDeliveryDate.order_code}-${this.state.modifyDeliveryDeliveryDate.suffix}`,
        delivery_id: this.state.modifyDeliveryDeliveryDate.id,
        requisition_id: this.state.requisitionDetail.requisition_id,
        action: 'modify_delivery_date'
      }

    }

    this.props.callDeliveryActions(data,
      {
        onSuccess: (response) => {
          // try {
          //   sendMessageToMultipleUsersInSocket(
          //     this.props.userId,
          //     response['users'],
          //     response['data']
          //   );
          // } catch(e) {
          //   console.log('modify products error: ', e)
          // }
          
          this.loadItems();
          this.setState({
            modifyDeliveryDeliveryDate: null,
            modifyDeliveryCollectionDate: null,
            requisitionId: this.state.requisitionDetail.id,
          });

          showSimpleFlashNotification('Se modificó con éxito', null);
        },
        onError: (e) => {
          this.setState({
            modifyDeliveryDeliveryDate: null,
            modifyDeliveryCollectionDate: null,
            errorMessage: e.response?.data?.error || 'Ocurrío un error, intente de nuevo'
          })
        }
      }
    )

  }

  render() {
    return (
      <View className="orders-control-view">

        {
          (this.props.isLoading) && 
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              backgroundColor: "#00000080",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1001,
              backdropFilter: "blur(3px)"
            }}
          >
            <div style={{display: "flex", alignItems: "center"}}>
              <Loader width="100px" height="100px"/>
              <div style={{color: "#fff", fontSize: "36px"}}>
                Cargando
              </div>
            </div>
            <div style={{color: "#fff", fontSize: "30px"}}>
              Si desea cancelar la consulta, presione ESC
            </div>
          </div>
        }

        <ViewTitle>
          <span>
            { this.getTitleValue() } 
          </span> 
        </ViewTitle>

        <div className="switches-container">

          <div/>
          
          {
            this.state.requisitionDetail !== null ? <div/> :
            <OptionSelectorSwitch
              value={this.state.transactionType}
              name="transactionType"
              onChange={this.handleTabChange}
              items={TRANSACTIONS}
            />
          }

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              marginBottom: 30
            }}
          >
            {
              this.state.requisitionDetail ? <div/> :
              <FilterBarCompact
                limit={350}
                multiText={true}
                searchStr={this.state.emails}
                searchPlaceholder={"Ingresa Número de Pedido"}
                clearMultiText={() => this.setState({ emails: [], searchStr: "" })}
                searchAction={this.handleEmailInput}
                filterAction={() => {

                  if (this.state.buttonFilterName === "Aplicar") {
                    this.setState(
                      {
                        offset: 1,
                        buttonFilterName: "Restablecer"
                      },
                      () => { this.loadItems(); }
                    );
                  } else {

                    this.setState({
                      offset: 1,
                      emails: [], 
                      searchStr: "",
                      appointment: [],
                      appointment_type: [],
                      requisition_status: [],
                      facilities_selected: [],
                      buttonFilterName: "Aplicar"
                    }, () => { this.loadItems(); })

                  }
                }}
                buttonFilterName={this.state.buttonFilterName}
                content={this.filterContent()}
                onChange={(e) => {
                  this.setState({
                    [e.target.name]: e.target.value,
                    emails: [], 
                    searchStr: '', 
                    buttonFilterName: "Aplicar"
                  })
                }}
                selectedItems={{
                  appointment: this.state.appointment,
                  appointment_type: this.state.appointment_type,
                  requisition_status: this.state.requisition_status,
                  facilities_selected: this.state.facilities_selected
                }}
              />
            }
          </div>

        </div>

        <div className="switches-container">

          <div/>
          
          <div/>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end'
            }}
          >
            {
              (this.state.transactionType !== 1 || this.state.requisitionDetail !== null) ? <div/> :
              <Button
                onClick={() => this.setState({showCreateOrderModal: true})}
                type={`primary`}
                text={"Crear Pedido de Compra"}
              />
            }
          </div>

        </div>

        <div className="content">

          <ResetButtonContainer>
            <div 
              className="reset-button"
              onClick={() => {

                if (this.state.requisitionDetail) {

                  this.setState({
                    deliveryFilter: {},
                    seed: Math.random()
                  });

                  this.props.updateRequisitionFilterConfig({
                    company_id: this.props.companyId,
                    delivery_filter: {}
                  });

                } else {

                  this.setState({
                    requisitionFilter: {},
                    seed: Math.random()
                  });

                  this.props.updateRequisitionFilterConfig({
                    company_id: this.props.companyId,
                    requisition_filter: {}
                  });

                }
              }}
            >{'Reestablecer acomodo de columnas'}</div>
          </ResetButtonContainer>

          {
            this.getHeaderInfoSelection()
          }

          {
            this.state.requisitionDetail ?
            <RequisitionDetailView
              key={this.state.seed}
              allSelected={this.state.isAllProductsSelected}
              isModeSelection={this.state.selectionModeOn}
              handleChange={this.handleGridChange}
              rowData={this.state.requisitionDetail.deliveries}
              requisition={this.state.requisitionDetail}
              configuration={this.state.deliveryFilter || {}}
              isLoading={this.props.isUpdatingFiltersLoading}
              setNewFilter={(new_filter) => {
                this.setState({
                  deliveryFilter: new_filter
                });

                this.props.updateRequisitionFilterConfig({
                  company_id: this.props.companyId,
                  delivery_filter: new_filter
                });
              }}
            />
            :
            <RequisitionView
              key={this.state.seed}
              allSelected={this.state.isAllRequisitionsSelected}
              isModeSelection={this.state.selectionModeOn}
              handleChange={this.handleGridChange}
              rowData={this.props.requisitionsData}
              transactionType={this.state.transactionType}
              configuration={this.state.requisitionFilter || {}}
              isLoading={this.props.isUpdatingFiltersLoading}
              setNewFilter={(new_filter) => {
                this.setState({
                  requisitionFilter: new_filter
                });

                this.props.updateRequisitionFilterConfig({
                  company_id: this.props.companyId,
                  requisition_filter: new_filter
                });
              }}
            />
          }

          <div style={{
            visibility: (this.state.requisitionDetail !== null) ? 'hidden' : 'visible'
          }}>
            <PaginatorControlled
              itemCount={this.getCount()}
              onChange={(e) => {
                this.setState({ [e.target.name]: e.target.value }, () => {
                  if (this.state.getOrdersCalled === true) {
                    this.loadItems();
                  }
                });
              }}
              limit={this.state.limit}
              offset={this.state.offset}
            />
          </div>    
        </div>

        {
          (this.state.productsSelected.length > 0 || this.state.requisitionsSelected.length > 0) &&
          <CatalogSelectionFooter
            key={`catalog-footer`}
            show={this.state.productsSelected.length > 0 || this.state.requisitionsSelected.length > 0 }
            selectedElements={this.state.productsSelected.length || this.state.requisitionsSelected.length }
            selectAll={() => {
              if (this.state.requisitionDetail === null) {
                this.setState({
                  isAllRequisitionsSelected: true,
                  seed: Math.random()
                });
              } else {
                this.setState({
                  isAllProductsSelected: true,
                  seed: Math.random()
                });
              }
            }}
            actions={
              (
                this.state.requisitionDetail === null ?
                [{
                  description: "Cancelar Pedidos",
                  error: this.getCancelRequisitionErrors(),
                  disabled: this.getCancelRequisitionErrors() !== null,
                  f: () => {
                    this.setState({cancelRequisitionsModal: true});
                  }
                },{
                  description: "Confirmar Pedidos",
                  error: this.getConfirmRequisitionErrors(),
                  disabled: this.getConfirmRequisitionErrors() !== null,
                  f: () => {
                    this.setState({confirmRequisitionsModal: true});
                  }
                }] : [{
                  description: "Eliminar",
                  error: this.getProductsError(),
                  disabled: this.getProductsError() !== null,
                  f: () => {
                    this.setState({removeProductsModal: true});
                  }
                }]
              ).concat(
                [
                  {
                    description: "Cerrar",
                    f: () => {
                      this.setState({seed: Math.random(), requisitionsSelected: [], isAllRequisitionsSelected: false, isAllProductsSelected: false, productsSelected: []});
                    },
                  },
                ]
              )
            }
          />
        }

        {
          this.state.showCreateOrderModal &&
          <CreateOrderModal
            show={this.state.showCreateOrderModal}
            onClose={() => {this.resetModal(); this.setState({showCreateOrderModal: false})}}
            handleChange={this.handleModalChange}
            currentFacilityName={this.state.facilityData ? this.state.facilityData["name"] : undefined}

            selectedProducts={this.state.productsToAdd}
            selectedProvider={this.state.selectedProvider}
            selectedFacility={this.state.selectedFacility}
            selectedTags={this.state.selectedTags}
            selectedCode={this.state.selectedCode}
            selectedDestiny={this.state.selectedDestiny}

            productCatalog={this.state.providerProducts}
            providerCatalog={this.props.companyProviders}
            facilitiesCatalog={this.state.providerFacilities}
            tagsCatalog={[]}
            unitsCatalog={this.props.companyUnits}

            facilitiesDestiny={this.state.facilityCatalog}
            isLoadingProducts={this.props.isLoadingProducts}
            moreProducts={this.state.moreProducts}
            isValidationLoading={this.props.isValidationLoading}
            isCreationLoading={this.props.isCreationLoading}
            selectedDate={this.state.selectedDate}
            clients={this.props.clients}
            companyType={this.props.companyType}
            selectedClient={this.props.companyType === 3 ? this.state.selectedClient : this.props.companyId}
          />
        }

        {
          this.state.test_modal &&
          <GenericDialog
            open={this.state.test_modal !== null}
            title={this.state.test_modal}
            message={'Mensaje de prueba'}
            acceptAction={() => this.setState({test_modal: null})}
            closeAction={() => this.setState({test_modal: null})}
          />
        }

        {
          this.state.error_message &&
          <GenericDialog
            open={this.state.error_message !== null}
            title={'Error'}
            message={this.state.error_message}
            acceptAction={() => this.setState({error_message: null})}
            closeAction={() => this.setState({error_message: null})}
          />
        }

        {
          this.state.codesNotFound.length > 0 &&
          <GenericDialog
            open={this.state.codesNotFound.length > 0}
            title={'Pedidos no encontrados:'}
            message={`${this.state.codesNotFound.join(', ')}`}
            acceptAction={() => this.setState({codesNotFound: []})}
            closeAction={() => this.setState({codesNotFound: []})}
          />
        }

        {
          this.state.divideRequisitionDelivery &&
          <DivideRequisitionDeliveryModal
            deliveryData={this.state.divideRequisitionDelivery}
            closeAction={() => this.setState({divideRequisitionDelivery: null})}
            requisition_id={this.state.requisitionDetail?.id}
            requisitionData={this.state.requisitionDetail}
            handleChange={this.handleGridChange}
            transactionType={this.state.transactionType === 1 ? 'buy' : 'sell'}
          />
        }

        {
          this.state.addProductRequisitionDelivery &&
          <AddProductRequisitionDeliveryModal
            deliveryData={this.state.addProductRequisitionDelivery}
            closeAction={() => this.setState({addProductRequisitionDelivery: null})}
            network_id={this.state.requisitionDetail?.network_id}
            requisition_id={this.state.requisitionDetail?.id}
            handleChange={this.handleGridChange}
            requisitionData={this.state.requisitionDetail}
            transactionType={this.state.transactionType === 1 ? 'buy' : 'sell'}
          />
        }

        {
          this.state.confirmRequisitionData !== null &&
          <ConfirmRequisitionModal
            requisitions={[this.state.confirmRequisitionData]}
            deliveries={this.state.confirmRequisitionData.deliveries || []}
            closeAction={() => {this.setState({confirmRequisitionData: null})}}
            handleChange={this.handleGridChange}
            transactionType={this.state.transactionType === 1 ? 'buy' : 'sell'}
          />
        }

        {
          this.state.confirmRequisitionsModal &&
          <ConfirmRequisitionModal
            requisitions={this.getRequisitionsToConfirm().requisitions || []}
            deliveries={this.getRequisitionsToConfirm().deliveries || []}
            closeAction={() => {this.setState({confirmRequisitionsModal: false})}}
            handleChange={this.handleGridChange}
            transactionType={this.state.transactionType === 1 ? 'buy' : 'sell'}
          />
        }

        {
          this.state.cancelRequisitionsModal &&
          <GenericDialog
            open={this.state.cancelRequisitionsModal}
            title={'¿Estás seguro?'}
            message={this.state.requisitionsSelected.length > 0 ? 'Esta acción cancelará los pedidos, y será irreversible' : `Esta acción cancelará este pedido ${this.state.cancelRequisitionFromActions.code}, y será irreversible`}
            isLoading={this.props.isRequisitionActionsLoading}
            acceptAction={() => {
              this.props.callActionRequisition({
                company_id: this.props.companyId,
                action: 'cancel_requisitions',
                requisitions: this.state.requisitionsSelected.length > 0 ? this.state.requisitionsSelected : [this.state.cancelRequisitionFromActions.id || -1],
                transaction_type: this.state.transactionType === 1 ? 'buy' : 'sell'
              }, {
                onSuccess: (response) => {

                  let errors = [];

                  if (response.errors && response.errors.length > 0) {
                    errors = response.errors;
                  }

                  try {
                    (response.notifications || []).map( item => {
                      sendMessageToMultipleUsersInSocket(
                        this.props.userId,
                        item['users'],
                        item['data']
                      );
                    });
                  } catch(e) {
                    console.log('cancel requisition error:', e)
                  }

                  showSimpleFlashNotification('Se realizaron los cambios con éxito', null);
                  this.loadItems();
                  this.setState({
                    cancelRequisitionsModal: false,
                    requisitionsSelected: [],
                    cancelRequisitionFromActions: null,
                    isAllRequisitionsSelected: false,
                    errorMessage: errors.length > 0 ? errors.join(', ') : null
                  });
                },
                onError: (e) => {
                  this.setState({
                    cancelRequisitionFromActions: null,
                    cancelRequisitionsModal: false,
                    requisitionsSelected: [],
                    isAllRequisitionsSelected: false,
                    error_message: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
                  })
                }
              })
            }}
            closeAction={() => {
              this.setState({cancelRequisitionsModal: false, cancelRequisitionFromActions: []})}
            }
          />
        }

        {
          this.state.deleteDelivery &&
          <GenericDialog
            open={this.state.deleteDelivery !== null}
            title={'¿Estás seguro?'}
            message={`Esta acción eliminará la entrega ${this.state.deleteDelivery.requisition_code} - ${this.state.deleteDelivery.suffix} y será irreversible`}
            isLoading={this.props.isProductLoading}
            acceptAction={() => {
              this.props.modifyProduct({
                company_id: this.props.companyId,
                delivery_id: this.state.deleteDelivery.id,
                delivery_code: `${this.state.deleteDelivery.requisition_code} - ${this.state.deleteDelivery.suffix}`,
                requisition_id: this.state.requisitionDetail.id,
                action: 'delete_delivery',
                facility: this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) : Number(this.state.requisitionDetail.from_facility.id),
                last_facility: this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) : Number(this.state.requisitionDetail.from_facility.id),
              }, {
                onSuccess: (response) => {
                  try {
                    sendMessageToMultipleUsersInSocket(
                      this.props.userId,
                      response['users'],
                      response['data']
                    );
                  } catch(e) {
                    console.log('delete delivery error: ', e)
                  }

                  this.loadItems();
                  this.setState({
                    requisitionId: this.state.requisitionDetail.id,
                    deleteDelivery: null,
                    requisitionDetail: null
                  });

                  showSimpleFlashNotification('Se eliminó con éxito la entrega', null);
                },
                onError: (e) => {
                  this.setState({
                    deleteDelivery: null,
                    error_message: e.response?.data?.error || 'Ocurrío un error, intente de nuevo'
                  })
                }
              });

            }}
            closeAction={() => {
              this.setState({deleteDelivery: null})}
            }
          />
        }

        {
          this.state.modifyProductData && 
          <ModifyProductDeliveryModal
            closeAction={() => this.setState({modifyProductData: null})}
            data={this.state.modifyProductData}
            deliveries={this.state.requisitionDetail.deliveries.filter( item => item.id === (this.state.modifyProductData.delivery_id || 0))}
            onClickAccept={(data) => { 

              data.company_id = this.props.companyId;
              data.requisition_id = this.state.requisitionDetail.id;
              data.action = 'modify_product_quantity';
              data.facility = this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) :  Number(this.state.requisitionDetail.from_facility.id)
              data.last_facility = this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) :  Number(this.state.requisitionDetail.from_facility.id)

              this.props.modifyProduct(data, {
                onSuccess: (response) => {

                  try {
                    sendMessageToMultipleUsersInSocket(
                      this.props.userId,
                      response['users'],
                      response['data']
                    );
                  } catch(e) {
                    console.log('modify products error: ', e)
                  }
                  
                  this.loadItems();
                  this.setState({
                    modifyProductData: null,
                    requisitionDetail: null,
                    requisitionId: this.state.requisitionDetail.id,
                  });

                  showSimpleFlashNotification('Se modificó con éxito el producto', null);
                },
                onError: (e) => {
                  this.setState({
                    modifyProductData: null,
                    errorMessage: e.response?.data?.error || 'Ocurrío un error, intente de nuevo'
                  })
                }
              });

            }}
            isUpdatingLoading={this.props.isProductLoading}
          />
        }

        {
          this.state.removeUniqueProductData &&
          <GenericDialog
            open={this.state.removeUniqueProductData !== null}
            title={'Eliminar Producto'}
            message={'¿Estás seguro de eliminar este producto?'}
            isLoading={this.props.isRequisitionActionsLoading}
            acceptAction={() => {
              this.props.callActionRequisition({
                company_id: this.props.companyId,
                action: 'remove_products',
                facility: this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) : Number(this.state.requisitionDetail.from_facility.id),
                last_facility: this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) : Number(this.state.requisitionDetail.from_facility.id),
                deliveries: [
                  {
                    id: this.state.removeUniqueProductData.id,
                    product_deliveries: this.state.removeUniqueProductData.products.map( item => item.id),
                    product_names: this.state.removeUniqueProductData.products.map( item => item.product_name),
                    code: this.state.removeUniqueProductData.code
                  }
                ]
              }, {
                onSuccess: (response) => {

                  let errors = [];

                  if (response.errors && response.errors.length > 0) {
                    errors = response.errors;
                  }

                  try {
                    (response.notifications || []).map( item => {
                      sendMessageToMultipleUsersInSocket(
                        this.props.userId,
                        item['users'],
                        item['data']
                      );
                    });
                  } catch(e) {
                    console.log('cancel requisitions error:', e)
                  }

                  showSimpleFlashNotification(`Se eliminaron los productos correctamente`, null);
                  this.loadItems();
                  this.setState({
                    requisitionId: this.state.requisitionDetail.id,
                    removeUniqueProductData: null,
                    productsSelected: [],
                    isAllProductsSelected: false,
                    requisitionDetail: null,
                    errorMessage: errors.length > 0 ? errors.join(', ') : null
                  });
                },
                onError: (e) => {
                  this.setState({
                    removeUniqueProductData: null,
                    productsSelected: [],
                    isAllProductsSelected: false,
                    error_message: e.response?.data?.error || 'Ocurrió un error, intente de nuevo',
                  })
                }
              });
            }}
            closeAction={() => {
              this.setState({removeUniqueProductData: null})}
            }
          />
        }

        {
          this.state.removeProductsModal &&
          <GenericDialog
            open={this.state.removeProductsModal}
            title={'Eliminar Productos'}
            message={'¿Estás seguro de eliminar estos productos?'}
            isLoading={this.props.isRequisitionActionsLoading}
            acceptAction={() => {
              let all_products_by_delivery = [];
              (this.state.requisitionDetail?.deliveries || []).map( delivery => {

                let total_products = this.state.productsSelected.filter( item => item.delivery_id === delivery.id).map(item => item.id);
                let total_product_names = this.state.productsSelected.filter( item => item.delivery_id === delivery.id).map(item => item.product_name);

                if (total_products.length > 0 && total_products.length < delivery.products.length) {
                  all_products_by_delivery.push({
                    id: delivery.id,
                    code: `${delivery.requisition_code}-${delivery.suffix}`,
                    product_deliveries: total_products,
                    product_names: total_product_names,
                  });
                } else if (total_products.length > 0 && total_products.length === delivery.products.length) {
                  all_products_by_delivery.push({
                    id: delivery.id,
                    code: `${delivery.requisition_code}-${delivery.suffix}`,
                    product_deliveries: total_products.slice(0, -1),
                    product_names: total_product_names.slice(0, -1)
                  });
                }

              });

              this.props.callActionRequisition({
                company_id: this.props.companyId,
                action: 'remove_products',
                facility: this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) : Number(this.state.requisitionDetail.from_facility.id),
                deliveries: all_products_by_delivery,
                last_facility: this.state.transactionType === 1 ? Number(this.state.requisitionDetail.to_facility.id) : Number(this.state.requisitionDetail.from_facility.id),
              }, {
                onSuccess: (response) => {

                  let errors = [];

                  if (response.errors && response.errors.length > 0) {
                    errors = response.errors;
                  }

                  try {
                    (response.notifications || []).map( item => {
                      sendMessageToMultipleUsersInSocket(
                        this.props.userId,
                        item['users'],
                        item['data']
                      );
                    });
                  } catch(e) {
                    console.log('cancel requisitions error:', e)
                  }

                  showSimpleFlashNotification(`Se eliminaron los productos correctamente`, null);

                  this.loadItems();
                  this.setState({
                    requisitionId: this.state.requisitionDetail.id,
                    removeProductsModal: false,
                    productsSelected: [],
                    isAllProductsSelected: false,
                    requisitionDetail: null,
                    errorMessage: errors.length > 0 ? errors.join(', ') : null
                  });
                },
                onError: (e) => {
                  this.setState({
                    removeProductsModal: false,
                    productsSelected: [],
                    isAllProductsSelected: false,
                    error_message: e.response?.data?.error || 'Ocurrió un error, intente de nuevo',
                  })
                }
              });

            }}
            closeAction={() => {
              this.setState({removeProductsModal: false})}
            }
          />
        }

        {
          this.state.convertDeliveryToOrderRequisition &&
          <ConvertDeliveryToOrderModal
            requitition={this.state.convertDeliveryToOrderRequisition}
            deliveries={this.state.convertDeliveryToOrderDeliveries}
            closeAction={() => this.setState({convertDeliveryToOrderRequisition: null, convertDeliveryToOrderDeliveries: []})}
            tagsCatalog={this.props.orderTags}
            handleChange={this.handleGridChange}
          />
        }

        {
          (this.state.modifyDeliveryCollectionDate || this.state.modifyDeliveryDeliveryDate) &&
          <>
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }}
              onClick={() => this.setState({modifyDeliveryCollectionDate: null, modifyDeliveryDeliveryDate: null})}
            />
            <CustomDatePicker
              withTime={false}
              format={'yyyy-MM-DD'}
              minDate={new Date()}
              dateSelected={this.transformToDate(
                this.state.modifyDeliveryCollectionDate ? (this.state.modifyDeliveryCollectionDate.collection_date || {} ) : this.state.modifyDeliveryDeliveryDate ? (this.state.modifyDeliveryDeliveryDate.delivery_date || {}) : {}
              )}
              timeSelected={null}
              handleChange={this.handleDataChange}
              onClose={() => {
                if (this.props.isCallDeliveryActions) return;
                this.setState({modifyDeliveryCollectionDate: null, modifyDeliveryDeliveryDate: null})
              }}
            />
          </>
        }

        {
          this.state.errorMessage !== null &&
          <GenericDialog
            open={this.state.errorMessage !== null}
            title={'Error'}
            message={this.state.errorMessage}
            acceptAction={() => this.setState({errorMessage: null})}
            closeAction={() => this.setState({errorMessage: null})}
          />
        }

      </View>
    );
  }

}

const mapStateToProps = (state) => {
  const companyType = state?.globalCatalog?.session?.company?.type?.id || 0;
  const companyId = state.globalCatalog.session.company.id;
  const requisitionsData = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.CATALOG2")["results"] || []; 
  const requisitionsCount = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.CATALOG2")["count"] || 0;

  const isRequisitionCatalogLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.CATALOG2']?.status?.isFetching || false;
  const isFiltersLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.FILTERCONFIGURATION']?.status?.isFetching || false;
  const isUpdatingFiltersLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.FILTERCONFIGURATION.UPDATE']?.status?.isFetching || false;
  const isRequisitionLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.RESUME']?.status?.isFetching || false;
  const companyUnits = getEntityItems(state, "COMPANIES.CATALOGS.UNITS");
  const isOwnProductsLoading = state?.api['COMPANIES.PRODUCTS']?.status?.isFetching || false;
  const isProductsLoading = state?.api['COMPANIES.ORDERS.CONTROL.PROVIDERS.PRODUCTSPARAMS']?.status?.isFetching || false;
  const isCreationLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.CREATIONV2']?.status?.isFetching || false;
  const isCodeValidationLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.ORDERS.VALIDATEREQUISITION']?.status?.isFetching || false;
  const isSignatureValidationLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.TRIPS.VALIDATESIGNATURE']?.status?.isFetching || false;
  const isRequisitionActionsLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.ACTIONS']?.status?.isFetching || false;
  const isProductLoading = state?.api['COMPANIES.ORDERS.CONTROL.PROVIDERS.NEWPRODUCTS']?.status?.isFetching || false;
  const companyTags = getEntityItems(state, "COMPANIES.TAGS"); 
  const orderTags = companyTags.filter(t => t.type === 7);
  const isRequisitionInfoLoading = state?.api['COMPANIES.ORDERS.CONTROL.PROVIDERS.REQUISITIONINFO']?.status?.isFetching || false;
  const isDeliveryInfoLoading = state?.api['COMPANIES.ORDERS.CONTROL.PROVIDERS.DELIVERYINFO']?.status?.isFetching || false;
  const isDeliveryProductLoading = state?.api['COMPANIES.ORDERS.CONTROL.PROVIDERS.DELIVERYPRODUCT']?.status?.isFetching || false;
  const isCallDeliveryActions = state?.api['COMPANIES.ORDERS.CONTROL.PROVIDERS.ACTIONSDELIVERY']?.status?.isFetching || false;

  let companyProviders = getEntityItems(state, "COMPANIES.ORDERS.CONTROL.PROVIDERS").reduce(
    (result, network) => {
      // let id = companyProviders.find(
      //   (provider) => provider.id === network.id
      // );
      if (network.from_companies.id === companyId) {
        if (network.to_companies.type === 2) {
          result.push({
            value: String(network.id),

            label: network.to_companies_alias.concat(
              " - ",
              network.to_companies_code,
              " - ",
              network.to_companies.orbi_id
            ),
            id: network.to_companies.id
          });
        }
      } else {
        if (network.from_companies.type === 2)
          result.push({
            // value: network.id,
            value: String(network.id),
            // label: network.from_companies.corporation_name,
            label: network.from_companies.orbi_id.concat(
              " - ",
              network.from_companies_alias,
              " - ",
              network.from_companies_code
            ),
            id: network.from_companies.id
          });
      }
      return result;
    },
    []
  );

  let clients = companyType === 3 ? cloneDeep(companyProviders) : [
      {
        value: state?.globalCatalog?.session?.company?.id || -1,
        label: `${state?.globalCatalog?.session?.company?.orbi_id || ''}`,
        id: state?.globalCatalog?.session?.company?.id || -1
      }
    ];

  if (companyType !== 3) {
    companyProviders.unshift(
      {
        value: '-1', // -1 se interpreta como propia
        label: `${state.globalCatalog.session.company.orbi_id}`,
        id: state.globalCatalog.session.company.id
      }
    );
  }

  return {
    clients,
    companyType,
    companyId,
    requisitionsData,
    requisitionsCount,
    isUpdatingFiltersLoading,
    isLoading: isRequisitionCatalogLoading || isFiltersLoading || isRequisitionLoading || isRequisitionInfoLoading || isDeliveryInfoLoading || isDeliveryProductLoading,
    companyProviders,
    companyUnits,
    isLoadingProducts: isOwnProductsLoading || isProductsLoading,
    isCreationLoading,
    isValidationLoading: isSignatureValidationLoading || isCodeValidationLoading,
    isRequisitionActionsLoading,
    userId: state.globalCatalog.session.user.id,
    isProductLoading,
    orderTags,
    isCallDeliveryActions
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    cancelMultipleRequests: () => dispatch(cancelMultipleRequests()),
    loadFacilityRequisitions: (params, opt) => dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.CATALOG2", params, opt)),
    loadRequisitionFilterConfig: (params, opt) => dispatch(readEntity("COMPANIES.REQUISITIONSCONTROL.FILTERCONFIGURATION", params, opt)),
    updateRequisitionFilterConfig: (params, opts) => dispatch(partialEntity("COMPANIES.REQUISITIONSCONTROL.FILTERCONFIGURATION.UPDATE", params, opts)),
    loadCompanyRequisitionsResume: (params, opt) => dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.RESUME", params, opt)),
    loadFacilityInfo: (params, opt) => dispatch(readEntity("COMPANIES.FACILITIES", params, opt)),
    loadCompanyProviders: (params, opts) => dispatch(readEntities("COMPANIES.ORDERS.CONTROL.PROVIDERS", params, opts)),
    loadCompanyUnits: (params, opts) => dispatch(readEntities("COMPANIES.CATALOGS.UNITS", params, opts)),
    loadProducts: (params, opt) => dispatch(readEntities("COMPANIES.PRODUCTS", params, opt)),
    loadProviderProducts: (params, opts) => dispatch(readEntities("COMPANIES.ORDERS.CONTROL.PROVIDERS.PRODUCTSPARAMS", params, opts)),
    createRequisitionV2: (params, opts) => dispatch(createEntity("COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.CREATIONV2", params, opts)),
    loadOwnFacilities: (params, opt) => dispatch(readEntities("COMPANIES.FACILITIES.TAGS", params, opt)),
    loadProviderFacilities: (params, opts) => dispatch(readEntities("COMPANIES.ORDERS.CONTROL.PROVIDERS.FACILITIESTAGS", params, opts)),
    validateCodeOrder: (params, opt) => dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.ORDERS.VALIDATEREQUISITION", params, opt)),
    callActionRequisition: (params, opts) => dispatch(partialEntity("COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.ACTIONS", params, opts)),
    modifyProduct: (params, opts) => dispatch(partialEntity("COMPANIES.ORDERS.CONTROL.PROVIDERS.NEWPRODUCTS", params, opts)),
    loadCompanyTags: (params, opts) => dispatch(readEntities("COMPANIES.TAGS", params, opts)),
    getRequisitionInfo: (params, opts) => dispatch(readEntity("COMPANIES.ORDERS.CONTROL.PROVIDERS.REQUISITIONINFO", params, opts)),
    getDeliveryInfo: (params, opts) => dispatch(readEntity("COMPANIES.ORDERS.CONTROL.PROVIDERS.DELIVERYINFO", params, opts)),
    getDeliveryProduct: (params, opts) => dispatch(readEntity("COMPANIES.ORDERS.CONTROL.PROVIDERS.DELIVERYPRODUCT", params, opts)),
    callDeliveryActions: (params, opts) => dispatch(partialEntity("COMPANIES.ORDERS.CONTROL.PROVIDERS.ACTIONSDELIVERY", params, opts)),
    setOrderDetail: (payload) => dispatch(setOrderSeleted(payload))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RequisitionsControlView);

const CaretContainer = styled.div`
  align-self: center;
  cursor: pointer;
`;

const ResetButtonContainer = styled.div`
  width: 100%;
  display: flex;
  height: 25px;
  justify-content: right;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;

  & .reset-button {
    cursor: pointer;
    font-size: 16px;
    text-decoration: underline;
    color: white;

    &:hover {
      font-size: 18px;
    }
  }
`;